import $ from 'jquery'
import Swiper from 'swiper'
import bottleSlider from './bottleSlider'
import { TweenMax } from 'gsap/gsap-core';

export default {
  init() {
    const slider = new Swiper('.home__slider', {
      allowTouchMove: false,
      loop: true,
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      on: {
        slideChange: function() {
          const barWidth = $(this.$el).find('.home__slider-scrollBar').width()
          const nbSlides = $(this.$el).find('.home__slider-slide:not(.swiper-slide-duplicate)').length
          $(this.$el).find('.home__slider-currentSlide').text(this.realIndex + 1 < 10 ? `0${this.realIndex + 1}` : this.realIndex + 1)
          $(this.$el).find('.home__slider-scrollBar-bar').css('margin-left', this.realIndex * (barWidth / nbSlides) + 'px')
        },
        init: function() {
          const barWidth = $(this.$el).find('.home__slider-scrollBar').width()
          const nbSlides = $(this.$el).find('.home__slider-slide:not(.swiper-slide-duplicate)').length
          $(this.$el).find('.home__slider-scrollBar-bar').css('width', barWidth / nbSlides + 'px')
        }
      }
    })

    const thumbs = new Swiper('.home__slider-thumbs', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      runCallbacksOnInit: false,
      speed: 1000,
      navigation: {
        nextEl: '.home__slider-thumbsNav-next',
        prevEl: '.home__slider-thumbsNav-prev',
      },
      scrollbar: {
        el: $('.home__slider-scrollBar'),
        draggable: false,
      },
      on: {
        slideNextTransitionStart: function() {
          slider.slideNext()
        },
        slidePrevTransitionStart: function() {
          slider.slidePrev()
        },
        slideChange: function() {
          $('.home__slider-currentSlide').text(slider.realIndex + 1 < 10 ? `0${slider.realIndex + 1}` : slider.realIndex + 1)
        },
        init: function() {
          const s = this

          $('.home__slider-thumbs-slide').on('click', function() {
            const index = parseInt($(this).attr('data-slide'))
            slider.slideToLoop(index)
            s.slideToLoop(index)
          })

          setInterval(() => {
            s.slideNext()
          }, 4000);
        }
      },
    })

    $('.home__slider-thumbsNav-next').on('click', () => {
      thumbs.slideNext()
    })

    $('.home__slider-thumbsNav-prev').on('click', () => {
      thumbs.slidePrev()
    })

    bottleSlider.init()

    $(window).on('scroll', () => {
      TweenMax.to($('.home__slider-slide-image'), .5, {
        scale: window.scrollY * 0.0005 + 1,
        force3D: true
      })
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
